/**
 * Sprint 4I1.C — Etichetta di "origine" del codice IVA selezionato.
 *
 * Mostra sotto un CodiceIvaPicker da dove arriva il valore corrente:
 *   - azienda    → "Da: Default azienda"
 *   - fornitore  → "Da: [Nome fornitore]"
 *   - ereditata  → "Da: riga collegata"
 *   - override   → "Override utente"
 *
 * Props: source: 'azienda'|'fornitore'|'override'|'ereditata'|null
 *        fornitoreNome?: string
 *        testId?: string
 */
import React from "react";

export default function OrigineIvaLabel({ source, fornitoreNome, testId }) {
  if (!source) return null;
  let txt = null;
  let cls = "text-slate-400";
  if (source === "azienda") {
    txt = "Da: Default azienda";
    cls = "text-amber-600";
  } else if (source === "fornitore") {
    txt = `Da: ${fornitoreNome || "Fornitore"}`;
    cls = "text-emerald-600";
  } else if (source === "ereditata") {
    txt = `Da: ${fornitoreNome || "riga collegata"}`;
    cls = "text-emerald-600";
  } else if (source === "override") {
    txt = "Override utente";
    cls = "text-rose-600";
  }
  if (!txt) return null;
  return (
    <span className={`text-[10px] mt-1 inline-block ${cls}`} data-testid={testId}>
      {txt}
    </span>
  );
}
